import { ColumnDef } from '@tanstack/react-table';

import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';

import { ShortcutCell } from './Components/Cells';
import messages from './messages';
import { ShortcutKey } from './ShortcutsContent.types';

const SHORTCUTS_COLUMNS: ColumnDef<ShortcutKey, any>[] = [
  {
    accessorKey: 'description',
    header: () => (
      <SafeFormattedMessageWithoutSpread message={messages.tableHeaderLabel} />
    ),
    size: 320,
  },
  {
    accessorKey: 'fragments',
    header: () => (
      <SafeFormattedMessageWithoutSpread
        message={messages.tableHeaderShortcut}
      />
    ),
    cell: ShortcutCell,
    size: 200,
  },
  {
    accessorKey: 'condition',
    header: () => (
      <SafeFormattedMessageWithoutSpread
        message={messages.tableHeaderCondition}
      />
    ),
    size: 280,
  },
];

export default SHORTCUTS_COLUMNS;
